<template>
  <div class="w-form-list">
    <div class="w-form-item flex-column" v-for="(item, index) in formList" :key="index">
      <div class="form-item-label">{{ item.label }}</div>
      <input v-model="formData[item.field]" type="text" :placeholder="item.placeholder" v-if="item.type === 'input'">
      <div class="flex-between form-item-content" @click="handleClick(item)" v-else>
        <div v-if="item.type === 'picker'" class="form-item-data" :class="{'no-content': !formData[item.field]}">
          {{ formData[item.field] || item.placeholder }}
        </div>
        <div v-else-if="item.type === 'router'">
          <div class="no-content" v-if="!formData[item.field]">{{ item.placeholder }}</div>
          <slot v-else :name="item.field"/>
        </div>
        <span class="iconfont iconchevron-right"/>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'w-form',
		props: {
			formList: {
				type: Array,
				default: () => []
			},
			formData: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {},
		methods: {
			handleClick (item) {
				this.$emit('handleClick', item)
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  .w-form-list {
    .w-form-item {
      padding: 24px 0 12px;
      border-bottom: 1px solid #EEEFF0;
      .form-item-label {
        font-size: $font-size-small;
        color: $color-dark-gray;
        margin-bottom: 12px;
      }
      input {
        height: 22px;
        border: none !important;
        padding-left: 0;
        font-size: $font-size-medium-x;
        &::placeholder {
          color: #BCBCBC;
        }
      }
      .form-item-content {
        align-items: flex-start;
        .form-item-data {
          color: $color-title;
          font-size: $font-size-medium-x;
        }
        .no-content {
          color: #BCBCBC;
          font-size: $font-size-medium-x;
        }
        .iconfont {
          color: #aaaaaa;
          font-weight: 500;
        }
      }
    }
  }
</style>
